module.exports = "/_next/static/images/maxcover-f6e4241c68b1789ca24b1229c3df543b.svg";